import {
  SPLIT_TARGET_PERCENTAGE,
  SPLIT_TOTAL_TARGET,
  convertSplitRatioToPercentage,
  getEvenlyDistributedSplitRatios,
} from "../../../modules/Invoice/pages/Wizard/pages/Details/components/salesPersonSplitUtils";

const toSalesPeopleRows = (salesPeople = []) =>
  salesPeople.map(({ salesUserId, split }) => ({ salesUserId, split }));

const getSplitTotalPercentage = (rows = []) =>
  convertSplitRatioToPercentage(
    rows.reduce((total, row) => total + Number(row?.split || 0), 0),
  );

const hasDuplicateSalesUsers = (rows = []) => {
  const salesUserIds = rows
    .map(row => row?.salesUserId)
    .filter(salesUserId => salesUserId != null);
  return new Set(salesUserIds).size !== salesUserIds.length;
};

// Returns the reason the rows cannot be saved, or null when they can. An empty
// list is valid and clears the people.
const getSalesPeopleRowsError = (rows = []) => {
  if (!rows.length) return null;
  if (rows.some(row => row?.salesUserId == null || row?.salesUserId === "")) {
    return "Select a sales user for every row.";
  }
  if (hasDuplicateSalesUsers(rows)) {
    return "Each sales user can only be added once.";
  }
  return getSplitTotalPercentage(rows) === SPLIT_TARGET_PERCENTAGE
    ? null
    : "Splits must add up to 100%.";
};

const splitRowsEqually = (rows = []) => {
  const splits = getEvenlyDistributedSplitRatios(
    SPLIT_TOTAL_TARGET,
    rows.length,
  );
  return rows.map((row, index) => ({ ...row, split: splits[index] }));
};

const toSalesPeopleInput = (rows = []) =>
  rows.map(({ salesUserId, split }) => ({
    salesUserId: Number(salesUserId),
    split: Number(split || 0),
  }));

// "Alice, Bob" for sales people carrying their `salesUser`, largest split first.
const formatSalesPeopleNames = (salesPeople = []) =>
  [...(salesPeople || [])]
    .sort((a, b) => Number(b?.split || 0) - Number(a?.split || 0))
    .map(salesPerson => salesPerson?.salesUser?.name)
    .filter(Boolean)
    .join(", ");

// A single unselected sales person holding the whole split, for new records.
const getEmptySalesPeopleRows = () => [{ salesUserId: null, split: 1 }];

export {
  formatSalesPeopleNames,
  getEmptySalesPeopleRows,
  getSalesPeopleRowsError,
  getSplitTotalPercentage,
  splitRowsEqually,
  toSalesPeopleInput,
  toSalesPeopleRows,
};
